import React, { useState, useEffect, useContext } from "react";
import { ToastContainer, toast } from "react-toastify";
import logoo from "../../images/LandingPageImage/Isancharr.svg";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";
import useAuthApi from "../../services/LandingPage/useAuthApi";
import useLogin from "../../services/LandingPage/useLogin";

const LoginPage = () => {
  const { setUser, setUserID } = useContext(GlobalContext);

  const [error, setError] = useState(null);
  const [MobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [Lerror, setLerror] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [LoginScreen, setLoginScreen] = useState("LOGIN");

  const { getUserAccess, fetchSubscriptionDetails } = useAuthApi();

  const {
    loginWithPasswordApi,
    sendOtpLogin,
    verifyOtpLogin,
    resendOtpLogin,
    sendForgetOtpApi,
    verifyForgetOtpApi,
    resetPasswordApi,
  } = useLogin();

  const navigate = useNavigate();

  const [ForgetNumber, setForgetNumber] = useState("");
  const [ForgetStep, setForgetStep] = useState(1);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmNewPassword, setConfirmNewPassword] = useState("");
  const [ForgetOtp, setForgetOtp] = useState(["", "", "", "", "", ""]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const isLoggedIn = sessionStorage.getItem("user");

  // ========== Validation & API flow  ==========
  function validateInputs() {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
    } else if (!password) {
      toast.error("Please enter your password");
    } else {
      LoginCall();
    }
  }

  const handleAuthSuccess = async (userData) => {
    sessionStorage.setItem("user", JSON.stringify(userData));
    sessionStorage.setItem("power", "1");

    setUser(userData);
    setUserID(userData.userid);

    await fetchSubscriptionDetails(userData.userid);
    await getUserAccess(userData.userid);

    navigate("/Dashboard");
  };

  const LoginCall = async () => {
    if (MobileNumber.length !== 10) {
      toast.error("Invalid Mobile number");
      return;
    }

    if (!password) {
      toast.error("Please enter your password");
      return;
    }

    const data = await loginWithPasswordApi(
      MobileNumber,
      password,
      latitude,
      longitude,
    );

    if (!data) return;

    if (data.responseCode === "00") {
      const userData = data.response;
      await handleAuthSuccess(userData);
    } else {
      toast.error(data.responseMessage);
    }
  };

  const handleForgotOtpChange = (e, index) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...ForgetOtp];
    newOtp[index] = val;
    setForgetOtp(newOtp);
    if (val !== "" && e.target.nextElementSibling) {
      e.target.nextElementSibling.focus();
    }
    if (val === "" && e.target.previousElementSibling) {
      e.target.previousElementSibling.focus();
    }
  };

  // Forgot password endpoints preserved

  const sendForgetOtp = async () => {
    const data = await sendForgetOtpApi(ForgetNumber);

    if (!data) return;

    if (data.responseCode === "00") {
      toast.success(data.responseMessage);
      setLoginScreen("OTPVERIFICATIONFORGET");
      setForgetStep(2);
    } else {
      toast.error(data.responseMessage);
    }
  };

  const verifyForgetOtp = async () => {
    const data = await verifyForgetOtpApi(ForgetNumber, ForgetOtp.join(""));

    if (!data) return;

    if (data.responseCode === "00") {
      toast.success(data.responseMessage);
      setLoginScreen("RESET_PASSWORD");
      setForgetStep(3);
    } else {
      toast.error(data.responseMessage);
    }
  };

  const resetPassword = async () => {
    if (NewPassword !== ConfirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }

    const data = await resetPasswordApi(
      ForgetNumber,
      NewPassword,
      ForgetOtp.join(""),
    );

    if (!data) return;

    if (data.responseCode === "00") {
      toast.success("Password reset successfully!");
      setLoginScreen("LOGIN");
    } else {
      toast.error(data.responseMessage);
    }
  };

  function ForgotPassWord() {
    setLoginScreen("FORGOTPASSWORD");
  }

  // Geolocation on mount (preserved)
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        },
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
          setLerror(err.message);
        },
      );
    } else {
      setError("Geolocation is not supported by your browser");
    }
  }, []);

  return (
    <>
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="relative min-h-screen overflow-hidden bg-gradient-to-b from-[#0A4E79] via-[#0A669B] to-[#0A84D6]">
        {/* grid background */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.09)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.09)_1px,transparent_1px)] bg-[size:47px_54px]" />

        {/* centered card */}
        <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-8">
          <div className="flex min-h-[570px] w-full max-w-[478px] flex-col rounded-md bg-[#f4f4f4] px-7 pt-8 pb-6 shadow-2xl">
            {/* logo */}
            <div className="mb-8 flex justify-center">
              <img
                src={logoo}
                alt="Logo"
                className="h-10 w-auto object-contain"
              />
            </div>

            {/* heading */}
            <div className="mb-8 text-center">
              <h2 className="text-[24px] font-semibold text-[#0B72B9]">
                Welcome
              </h2>
              <p className="mt-1 text-[18px] text-[#474747]">
                Login With Your Mobile Number
              </p>
            </div>

            {/* form */}
            <div className="flex-1">
              {LoginScreen === "LOGIN" && (
                <>
                  <div className="mb-3">
                    <label className="mb-1 block text-[18px] font-medium text-[#3a3a3a]">
                      Mobile Number
                    </label>

                    <div className="flex h-[44px] items-center overflow-hidden rounded-[6px] border border-[#d9d9d9] bg-[#f8f8f8]">
                      <span className="px-3 text-[15px] text-[#222] font-bold">
                        +91
                      </span>
                      <input
                        type="tel"
                        placeholder="Enter Mobile Number"
                        value={MobileNumber}
                        onChange={(e) =>
                          setMobileNumber(e.target.value.replace(/[^0-9]/g, ""))
                        }
                        className="h-full w-full bg-transparent pr-3 text-[16px] font-semibold text-[#222] outline-none placeholder:font-normal placeholder:text-[#9f9f9f]"
                      />
                    </div>
                  </div>

                  <div className="mb-2">
                    <label className="mb-1 block text-[18px] font-medium text-[#3a3a3a]">
                      Password
                    </label>

                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="h-[44px] w-full rounded-[6px] border border-[#d9d9d9] bg-[#f8f8f8] px-3 text-[16px] font-semibold text-[#222] outline-none placeholder:font-normal placeholder:text-[#9f9f9f]"
                    />
                  </div>

                  <div className="mb-8 flex items-center gap-2">
                    <input
                      id="showPassword"
                      type="checkbox"
                      checked={showPassword}
                      onChange={togglePasswordVisibility}
                      className="h-3 w-3 cursor-pointer border border-[#cfcfcf]"
                    />
                    <label
                      htmlFor="showPassword"
                      className="cursor-pointer text-[16px] text-[#5f5f5f]"
                    >
                      Show Password
                    </label>
                  </div>

                  <button
                    type="button"
                    onClick={validateInputs}
                    className="h-[40px] w-full rounded-[6px] bg-[#0B72B9] text-[18px] font-medium text-white transition hover:bg-[#095f99]"
                  >
                    Login
                  </button>

                  <button
                    type="button"
                    onClick={() => setLoginScreen("FORGOTPASSWORD")}
                    className="h-[44px] w-full mt-3 rounded-[6px] border border-[#d9d9d9] bg-[#f8f8f8] px-3 text-[16px] font-semibold text-[#222] outline-none placeholder:font-normal placeholder:text-[#9f9f9f]"
                  >
                    Forget Password
                  </button>
                </>
              )}

              {LoginScreen === "FORGOTPASSWORD" && (
                <>
                  <input
                    type="tel"
                    placeholder="Enter Mobile Number"
                    value={ForgetNumber}
                    onChange={(e) => setForgetNumber(e.target.value)}
                    className="h-[31px] w-full mt-3 border px-3"
                  />

                  <button
                    onClick={sendForgetOtp}
                    className="h-[40px] w-full mt-3 bg-blue-600 text-white"
                  >
                    Send OTP
                  </button>

                  <p
                    onClick={() => setLoginScreen("LOGIN")}
                    className="text-sm text-blue-500 cursor-pointer mt-3"
                  >
                    Back to Login
                  </p>
                </>
              )}

              {LoginScreen === "OTPVERIFICATIONFORGET" && (
                <>
                  <div className="flex gap-2 mt-3">
                    {ForgetOtp.map((digit, index) => (
                      <input
                        key={index}
                        value={digit}
                        onChange={(e) => handleForgotOtpChange(e, index)}
                        maxLength={1}
                        className="w-11 h-11 border text-center text-[18px] font-semibold text-[#222] rounded-[6px]"
                      />
                    ))}
                  </div>

                  <button
                    onClick={verifyForgetOtp}
                    className="h-[40px] w-full mt-3 bg-blue-600 text-white"
                  >
                    Verify OTP
                  </button>

                  <p
                    onClick={() => setLoginScreen("FORGOTPASSWORD")}
                    className="text-sm text-blue-500 cursor-pointer mt-3"
                  >
                    Back
                  </p>
                </>
              )}

              {LoginScreen === "RESET_PASSWORD" && (
                <>
                  <input
                    type="password"
                    placeholder="New Password"
                    value={NewPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="h-[31px] w-full mt-3 border px-3"
                  />

                  <input
                    type="password"
                    placeholder="Confirm Password"
                    value={ConfirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    className="h-[31px] w-full mt-3 border px-3"
                  />

                  <button
                    onClick={resetPassword}
                    className="h-[40px] w-full mt-3 bg-blue-600 text-white"
                  >
                    Reset Password
                  </button>

                  <p
                    onClick={() => setLoginScreen("LOGIN")}
                    className="text-sm text-blue-500 cursor-pointer mt-3"
                  >
                    Back to Login
                  </p>
                </>
              )}
            </div>

            {/* footer */}
            <div className="mt-16 flex items-center justify-center gap-3 text-[16px] text-[#444]">
              <a href="/privacy" className="hover:underline text-blue-600">
                Privacy
              </a>
              <a
                href="/terms&conditions"
                className="hover:underline text-blue-600"
              >
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
